import Header from "../Header/Header";
import Select from "react-select";
import React, { useState, useEffect } from "react";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Image_URL } from "../commonApi/CommonApi";
import { Helmet } from "react-helmet";
import CustomImage from "../CustomImage/CustomImage";
// const BASE_URL = "http://localhost:5500";
// const BASE_URL = "http://52.87.3.228:5500";

function ChildCategory() {
  const [selectedFile, setSelectedFile] = useState();
  const [imagePreview, setImagePreview] = useState();
  const [childCat, setChildcategory] = useState([]);

  const [childCategoryName, setChildCategoryName] = useState("");
  const [notice, setNotice] = useState("");
  const [status, setStatus] = useState("");
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [isCombo, setIsCombo] = useState(0);
  const [isCustomize, setIsCustomize] = useState(0);
  const [isEditable, setIsEditable] = useState(0);

  // const [servicetype, setServicetype] = useState([]);
  const [parentCategory, setParentCategoryGroups] = useState([]);
  const [key, setKey] = useState(0);
  const [deleteChildCat, setDeleteChildCat] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const getChildCategory = async () => {
    try {
      const response = await privateRequest.get(
        `ChildCategory/ChildcategoryByStatus`
      );
      setChildcategory(response?.data?.data || []);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getParentCategory = async () => {
    try {
      const response = await privateRequest.get(
        `ParentCategory/Parentcategory`
      );
      setParentCategoryGroups(response?.data?.Data);
      setKey((prevKey) => prevKey + 1);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const resetFormFields = () => {
    setSelectedItemId("");
    setChildCategoryName("");
    setNotice("");
    setStatus("");
    setSelectedGroup(null);
    setImagePreview(null);
  };

  const deleteChild = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `ChildCategory/DeleteChildcategory/${_id}`
        );

        setDeleteChildCat(deleteChildCat.filter((item) => item._id !== _id));
        getChildCategory();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  const handleChildCategorySubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append("CCName", childCategoryName);
      formData.append("CCimage", selectedFile);
      formData.append("CCNotice", notice);
      formData.append("status", status);
      formData.append("Iscombo", isCombo == true ? 1 : 0);
      formData.append("Isedit", isEditable == true ? 1 : 0);
      formData.append("Iscustomize", isCustomize == true ? 1 : 0);

      selectedGroup.forEach((group) => {
        formData.append("PCName", group.value);
      });

      let response;
      if (selectedItemId) {
        response = await privateRequest.put(
          `ChildCategory/UpdateChildcategory/${selectedItemId}`,
          formData
        );
      } else {
        response = await privateRequest.post(
          `ChildCategory/Childcategory`,
          formData
        );
      }

      console.log("POST/PUT Response:", response);
      getChildCategory();
      setShowModal(false);
      setSelectedItemId("");
      setChildCategoryName("");
      setNotice("");
      setStatus("");
      setSelectedGroup([]);
      setSelectedFile(null);
      setImagePreview(null);
      setIsCustomize(0);
      setIsCombo(0);
      setIsEditable(0);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: selectedItemId
          ? "Child category updated successfully!"
          : "Child category added successfully!",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response.data.message,
      });
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getChildCategory();
    getParentCategory();
  }, []);

  useEffect(() => {
    getChildCategory();
    getParentCategory();
  }, []);

  return (
    <>
      {childCat.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Child Category</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={() => {
                        setShowModal(true);
                        setSelectedItemId("");
                        setChildCategoryName("");
                        setNotice("");
                        setStatus("");
                        setSelectedGroup([]);
                        setSelectedFile(null);
                        setImagePreview(null);
                        setIsCustomize(0);
                        setIsCombo(0);
                        setIsEditable(0);
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm dataTable no-footer "
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">
                              <i className="fa fa-image"></i>
                            </th>
                            <th scope="col">Cat Name</th>
                            <th scope="col" style={{ width: "200px" }}>
                              P Cat Name
                            </th>
                            <th scope="col">Notice</th>
                            <th scope="col">Status</th>
                            <th scope="col">Created</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {childCat.length === 0 ? (
                            <tr>
                              <td colSpan="9" className="text-center">
                                No data found
                              </td>
                            </tr>
                          ) : (
                            childCat.map((item, index) => (
                              <tr key={index}>
                                <td className="align-center">{index + 1}</td>
                                <td className="align-center">
                                  {item?.CCimage && (
                                    <img
                                      src={`${Image_URL}${item?.CCimage}`}
                                      className="rounded-pill"
                                      height="50"
                                      width="50"
                                    />
                                  )}
                                </td>
                                <td className="align-center">{item?.CCName}</td>
                                <td className="align-center">
                                  {item &&
                                    item?.PCName?.map((pc, index) => (
                                      <span
                                        key={index}
                                        className="badge badge-primary mr-1"
                                      >
                                        {pc?.PCName}
                                      </span>
                                    ))}
                                </td>
                                <td className="align-center">
                                  {item?.CCNotice}
                                </td>
                                <td>
                                  <span
                                    className={`badge ${
                                      item?.status === "0"
                                        ? "badge-danger"
                                        : "badge-primary"
                                    }`}
                                  >
                                    {item?.status === "1"
                                      ? "Active"
                                      : "Inactive"}
                                  </span>
                                </td>
                                <td className="align-center">
                                  <p className="mb-0">
                                    {item?.CreatedBy?.name}
                                  </p>
                                  <p className="mb-0">
                                    {new Date(
                                      item.createdAt
                                    ).toLocaleDateString("en-US", {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    })}
                                  </p>
                                </td>
                                <td className="align-center">
                                  <div className="btn-group">
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() => {
                                        setSelectedItemId(item._id);
                                        setChildCategoryName(item.CCName);
                                        setNotice(item.CCNotice);
                                        setStatus(item.status);
                                        setSelectedGroup(
                                          item.PCName.map((category) => ({
                                            value: category._id,
                                            label: category.PCName,
                                          }))
                                        );
                                        setIsCombo(item?.Iscombo);
                                        setIsCustomize(item?.Iscustomize);
                                        setIsEditable(item?.Isedit);
                                        setImagePreview(
                                          Image_URL + item?.CCimage
                                        );

                                        setShowModal(true);
                                      }}
                                    >
                                      <i className="fa fa-edit"></i>
                                    </button>
                                    <button
                                      className="btn btn-danger btn-sm"
                                      onClick={() => deleteChild(item._id)}
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="childModal"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content ">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Child Category
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => {
                  setShowModal(false);
                  setSelectedItemId("");
                }}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleChildCategorySubmit}>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Child Category</label>
                      <input
                        type="text"
                        id="inputName"
                        className="form-control"
                        placeholder="Child Category"
                        value={childCategoryName}
                        onChange={(e) => setChildCategoryName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Select Parent Category</label>
                      <Select
                        isMulti
                        placeholder={"Parent Category"}
                        options={parentCategory.map((group) => ({
                          value: group._id,
                          label: group.PCName,
                        }))}
                        onChange={(selectedOptions) =>
                          setSelectedGroup(selectedOptions)
                        }
                        value={selectedGroup}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Notice</label>
                      <input
                        type="text"
                        id="inputNotice"
                        className="form-control"
                        placeholder="Notice"
                        value={notice}
                        onChange={(e) => setNotice(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="form-group">
                      <label className="mb-0">Status</label>
                      <select
                        className="form-control"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-3 d-flex justify-content-start align-items-center">
                    <div className="custom-control custom-control-inline custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="ckb1"
                        name="spCommentShow"
                        checked={isCombo == 1 ? true : false}
                        value="1"
                        onChange={(e) => {
                          setIsCombo(!isCombo);
                        }}
                      />

                      <label className="custom-control-label" htmlFor="ckb1">
                        Is Combo
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-3 d-flex justify-content-start align-items-center">
                    <div className="custom-control custom-control-inline custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="ckb2"
                        name="spCommentShow"
                        checked={isCustomize == 1 ? true : false}
                        value="1"
                        onChange={(e) => {
                          setIsCustomize(!isCustomize);
                        }}
                      />
                      <label className="custom-control-label" htmlFor="ckb2">
                        Is Customize
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-3 d-flex justify-content-start align-items-center">
                    <div className="custom-control custom-control-inline custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="ckb3"
                        name="spCommentShow"
                        checked={isEditable == 1 ? true : false}
                        value="1"
                        onChange={(e) => {
                          setIsEditable(!isEditable);
                        }}
                      />
                      <label className="custom-control-label" htmlFor="ckb3">
                        Is Editable
                      </label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-4">
                    <CustomImage
                      setImagePreview={setImagePreview}
                      imagePreview={imagePreview}
                      setSelectedFile={setSelectedFile}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12 mt-3">
                    <div className="form-group text-left">
                      <button type="submit" className="btn btn-primary">
                        {selectedItemId ? "Update" : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default ChildCategory;
